module.exports = __webpack_public_path__ + "img/apply.687996e4.webp";